import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConfigfileService {

  constructor(private httpClient: HttpClient) { }
  private appConfig;
  jsonProperty
  loadConfig(){
    return this.httpClient.get<any>("assets/domainProperty.json").
    toPromise().then(res=>{
       this.jsonProperty = res.filter(domainName => {        
   environment.baseUrl= domainName.baseUrl;
   environment.rbackApi=domainName.rbackApi;
   environment.redirecturl =domainName.redirecturl;
 
 })

      this.appConfig=res;
    })
}
getConfig(){
return this.appConfig;
}
}
